<template>
  <main class="full-height">
    <v-content>
      <v-container fluid grid-list-xl>
        <v-layout justify-center row wrap>
          <v-flex xs12 class="text-xs-center">
            <v-layout xs12 row wrap>
              <button
                type="button"
                class="button-return-filters"
                @click="$router.go(-1)"
              >
                <v-icon>arrow_back</v-icon>
              </button>
              <v-flex xs12 class="mb-4">
                <h2 class="font-weight-black">
                  Consulta de Extrato de Produção
                </h2>
              </v-flex>

              <v-flex xs12 class="container-card">
                <v-card class="form-card">
                  <v-card-title class="justify-center"
                    >Permitirá você listar seus extratos de produção, podendo
                    efetuar a impressão desses documentos.</v-card-title
                  >
                  <v-container>
                    <label for="radioFilter" class="titulo-data"
                      >Apólices</label
                    >
                    <v-radio-group
                      id="radioFilter"
                      v-model="filterRadio"
                      class="box-radio"
                      row
                    >
                      <v-radio label="Vigentes" :value="true"></v-radio>
                      <v-radio label="Todas" :value="false"></v-radio>
                    </v-radio-group>

                    <div class="box-select">
                      <div class="overflow-select">
                        <v-select
                          :items="itensGrupoModalidade"
                          v-model="grupoModalidade"
                          label="Grupo de Modalidade"
                          class="jns-input input-width long-value-input"
                          placeholder="Grupo de Modalidade"
                          @keyup.enter="pesquisar()"
                          dense
                        ></v-select>
                      </div>
                      <v-spacer class="space"> </v-spacer>
                      <div class="overflow-select">
                        <v-select
                          :items="itensModalidade"
                          v-model="modalidade"
                          label="Modalidade"
                          class="jns-input input-width"
                          placeholder="Modalidade"
                          @keyup.enter="pesquisar()"
                          dense
                        ></v-select>
                      </div>
                    </div>

                    <p class="titulo-data">Período de Vigência</p>
                    <div class="box-filter-date">
                      <v-text-field
                        type="date"
                        v-model="dateVigenciaInicio"
                        class="jns-input"
                        label="Início"
                        placeholder=" "
                        @keyup.enter="pesquisar()"
                      ></v-text-field>

                      <span>à</span>

                      <v-text-field
                        type="date"
                        v-model="dateVigenciaFim"
                        class="jns-input"
                        placeholder=" "
                        label="Fim"
                        @keyup.enter="pesquisar()"
                      ></v-text-field>
                    </div>
                    <p class="titulo-data">Data de Emissão</p>
                    <div class="box-filter-date">
                      <v-text-field
                        type="date"
                        v-model="dateEmissaoInicio"
                        class="jns-input"
                        placeholder=" "
                        label="Início"
                        @keyup.enter="pesquisar()"
                      ></v-text-field>

                      <span>à</span>

                      <v-text-field
                        type="date"
                        v-model="dateEmissaoFim"
                        class="jns-input"
                        placeholder=" "
                        label="Fim"
                        @keyup.enter="pesquisar()"
                      ></v-text-field>
                    </div>

                    <v-text-field
                      v-model="segurado"
                      label="Segurado"
                      placeholder="Nome do segurado"
                      class="jns-input segurado"
                      @keyup.enter="pesquisar()"
                    ></v-text-field>

                    <v-layout row wrap class="justify-center">
                      <v-flex xs8>
                        <button
                          class="jns-button yellow-button"
                          @click="pesquisar()"
                        >
                          Pesquisar
                        </button>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </main>
</template>

<script>
import ViewMixin from "@/mixins/ViewMixin";

export default {
  name: "ExtratosPesquisar",
  mixins: [ViewMixin],
  data: () => ({
    filterRadio: true,
    itensGrupoModalidade: [],
    grupoModalidade: null,
    itensModalidade: [],
    modalidade: null,
    dateVigenciaInicio: null,
    dateVigenciaFim: null,
    dateEmissaoInicio: null,
    dateEmissaoFim: null,
    segurado: null,
    filtros: [],
  }),
  methods: {
    init() {
      Promise.all([this.getFilters()]);
    },

    async getFilters() {
      /*
      * Implementação para simular dados em cache durante o uso da tela de ExtratosListar. 
      * Ao destruir está deletando as váriaveis no localstorage
      */
      const filtersStorageModalidades = localStorage.getItem('@filtros-ext-prod-modalidades');
      const filtersStorageGrupos = localStorage.getItem('@filtros-ext-prod-grupo');

      if(!filtersStorageModalidades || !filtersStorageGrupos){
        try {
          this.showLoadingAskWait();
          const me = await this.$store.dispatch("GET_ME");
          this.filtros = await this.$store.dispatch("GET_FILTERS_APOLICES", {
            cnpj: me.company.document,
          });
          localStorage.setItem('@filtros-ext-prod-modalidades', JSON.stringify(this.filtros.modalidade));
          localStorage.setItem('@filtros-ext-prod-grupo', JSON.stringify(this.filtros.grupo_credito));
        } catch (e) {
          
        } finally {
          this.itensModalidade = this.filtros.modalidade;
          this.itensGrupoModalidade = this.filtros.grupo_credito;
          this.hideLoadingAskWait();
        }
      } else {
        this.itensModalidade = JSON.parse(filtersStorageModalidades);
        this.itensGrupoModalidade = JSON.parse(filtersStorageGrupos);
      }
    },

    async pesquisar() {
      const {
        filterRadio,
        grupoModalidade,
        modalidade,
        dateVigenciaInicio,
        dateVigenciaFim,
        dateEmissaoInicio,
        dateEmissaoFim,
        segurado,
      } = this;

      try {
        await this.$store.commit("SET_SEARCH_DATA_EXTRATO", {
          segurado: segurado,
          vigencia_inicio: dateVigenciaInicio,
          vigencia_fim: dateVigenciaFim,
          emissao_inicio: dateEmissaoInicio,
          emissao_fim: dateEmissaoFim,
          modalidade: modalidade,
          grupo_modalidade: grupoModalidade,
          id_grp_sub_limite: null,
          vigente: filterRadio,
        });
        this.$router.push({ path: `/extratos/listar` });
      } catch (e) {
        this.defaultHandlerError(e);
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
#jns {
  .full-height {
    .v-content {
      padding: 50px 0 0 80px !important;
    }
    .text-xs-center {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .container {
        padding: 10px 40px;
      }

      .form-card {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        width: 80%;

        .titulo-data {
          display: flex;
          text-align: left;
          color: #061d45;
          font-weight: bold;
        }

        .box-radio {
          display: flex;
          margin: 0 0 1rem 0;
        }

        .box-select {
          display: flex;
          flex-direction: column;
          width: 100%;

          .overflow-select {
            display: flex;
            overflow: hidden;

            .input-width {
              display: flex;
              width: 100%;
              margin: 20px 0 0 2px;
              font-size: 1rem;

              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .space {
            width: 5%;
          }
        }

        .box-filter-date {
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 0 1rem 0;

          span {
            width: 5%;
            color: #061d45;
            font-weight: bold;
          }
        }

        .segurado {
          margin: 0 0 1rem 0;
        }

        .justify-center {
          .jns-button {
            margin-bottom: 2rem;
          }
        }
      }

      @media screen and (max-width: 1300px) {
        .container {
          padding: 20px 20px;
        }

        .form-card {
          width: 100% !important;

          .box-select {
            flex-direction: column;

            .input-width {
              width: 100% !important;
              margin: 1rem 0;
            }

            .space {
              display: none;
            }
          }

          .box-filter-date {
            flex-direction: column;

            .jns-input {
              width: 100%;
              margin-bottom: 1rem;
            }
            span {
              display: none;
            }
          }
        }
      }
    }

    .button-return-filters {
      transition: all 0.3s;
      position: absolute;
      border-radius: 50%;
      background-color: #f1e41e;

      i {
        padding: 5px;
        font-size: 2rem;
        color: #061d45;
      }

      &:hover {
        background-color: #061d45;

        i {
          color: #fff;
        }
      }
    }

    @media (max-width: 480px) {
      .button-return-filters {
        position: relative;
      }
    }

    .container-card {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/router/views/ExtratosRecibos/ExtratosEmissaoProducao/Pesquisar.vue